import React from 'react';

export default function StorefrontNav({ sections, activeSection, onSelect }) {
    return (
        <nav className="sfm-nav" aria-label="Storefront settings">
            {sections.map(section => (
                <button
                    key={section.key}
                    type="button"
                    className={`sfm-nav-item${activeSection === section.key ? ' active' : ''}`}
                    aria-current={activeSection === section.key ? 'page' : undefined}
                    onClick={() => onSelect(section.key)}
                >
                    {section.label}
                </button>
            ))}
        </nav>
    );
}
